export { default } from './OrderDetails.vue';